<h2 mat-dialog-title class="announcement-dialog__title-wrapper">
  <span class="announcement-dialog__title">{{ title }}</span>
  <span *ngIf="data.announcement.is_global" class="announcement-dialog__badge">
    {{ 'announcementDialog.global' | translate }}
  </span>
</h2>

<div class="announcement-dialog__icon">
  <app-icon name="bullhorn-outline" [size]="IconSize.Large"></app-icon>
</div>

<mat-dialog-content class="announcement-dialog__content">
  <p>{{ content }}</p>
</mat-dialog-content>

<div class="announcement-dialog__actions">
  <app-button
    [skin]="ButtonSkin.Primary"
    [size]="ButtonSize.Medium"
    [type]="ButtonType.Button"
    (click)="close()"
  >
    {{ 'announcementDialog.okay' | translate }}
  </app-button>
</div>
